import type { FaireProductEntity } from "../../entity_types/product";

export const p_epwqvzs9et: FaireProductEntity = {
  token: "p_epwqvzs9et",
  type: "product",
  name: "Katana Key Chain",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/2ab604ba5081110b6ec0714a023a5e5adea5441028ea3851721fd7520d749d7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a0c2dd9807a6eb0bb534e4312116371af9a3bd0a459bb4216721e24bb05be76.jpeg",
    "https://cdn.faire.com/fastly/3dec90e23c8a42c0ebf06d7933c5db5fe4814be7a39bd5f6a494d1fa9106c71a.jpeg",
    "https://cdn.faire.com/fastly/af05f0e911fb5ae21f4cd1332239b0c085d9d7a018ea2b92af7a0ddfe5458e7b.gif"
  ],
  priceDollars: 2,
  description: "Carry a little samurai spirit everywhere with this katana key chain. Shaped like a miniature Japanese sword, it makes a fun add-on for gift shops, anime and martial arts stores, and a souvenir for fans of Japanese culture.\n\nFeatures\n\n * Katana design: a miniature Japanese sword for keys, bags and backpacks \n * Gift-shop favorite: an easy impulse buy for checkout counters \nSpecifications\n\n * Inner pack: 5 \n * Case pack: 300 \n * Origin: China ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:50.971Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
